import React from 'react';
import './AiMatchMenuButton.css';
import PageButton from '../../elements/PageButton/PageButton';
import {AI_MATCH_SHORT_TITLE} from '../../../configs/aiMatch';
import {getAiPromoCountdown, getAiPromoStartLabel} from '../../../utils/aiMatch/getAiPromoStartLabel';
import {checkIfAiPromoJoinable} from '../../../utils/aiMatch/checkIfAiPromoJoinable';
import {useSecondTick} from '../../../hooks/react/useSecondTick';

/**
 * Кнопка «Битва с Claude Opus» в главном меню — над рейтинговым матчем, в
 * цвете алмазной лиги, с иконкой ИИ слева (как эмблема лиги у рейтингового
 * матча). Вторая строка — отсчет, как в промо-модалке и в самом лобби: «Сбор
 * игроков 5 мин 0 сек» до 21:00, «Старт через 7 мин 5 сек» после (тикает раз
 * в секунду), — или «Смотреть матч», если матч уже идет (вход тогда —
 * зрителем). Пока лобби дня нет, день отменен или матч сыгран — кнопки нет
 * вовсе (см. getAiPromoStartLabel).
 *
 * Что делать по клику, решает меню: гостю — модалка входа, вошедшему — вход в
 * лобби дня (joinAiPromoLobby в App.js).
 *
 * @param {Object|null} aiPromo - результат normalizeAiPromo (useAiPromoLobby)
 * @param {number} serverTimeDelta - поправка часов: время сервера = Date.now() + она
 * @param {boolean} isGuest
 * @param {Function} onClick
 */
const AiMatchMenuButton = ({aiPromo, serverTimeDelta = 0, isGuest, onClick}) => {
  const now = Date.now() + serverTimeDelta;
  // Часы тикают, только пока на кнопке отсчет («Сбор игроков» или «Старт через»)
  useSecondTick(checkIfAiPromoJoinable(aiPromo) && getAiPromoCountdown(aiPromo, {now}) != null);

  const hint = getAiPromoStartLabel(aiPromo, {now});
  if (!hint) {
    return null;
  }

  return (
    <PageButton
      className={'main-menu-button_ai-match main-menu-button_with-hint'}
      onClick={onClick}
      pageId={'MainMenu'}
      buttonId={'ai_match'}
      buttonValue={aiPromo.status}
      isGuest={isGuest}
    >
      <span className={'main-menu-button_label'}>{AI_MATCH_SHORT_TITLE}</span>
      <span className={'main-menu-button_hint'}>{hint}</span>
    </PageButton>
  );
};

export default AiMatchMenuButton;
